var _g, _g2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDevvioLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "237px",
    height: "270px",
    viewBox: "0 0 2370 2700",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "layer101",
    fill: "#bababa",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M702 2623 c-4 -10 -7 -211 -7 -447 l0 -429 372 -206 372 -206 3 -429 3 -430 315 -183 c352 -205 429 -247 438 -238 7 7 4 1129 -4 1475 l-7 266 -406 234 c-728 419 -1061 610 -1066 610 -3 0 -9 -8 -13 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152 1138 l3 -552 255 -148 c505 -293 660 -380 674 -375 20 8 29 354 19 761 l-8 330 -55 31 c-30 18 -154 90 -275 160 -401 234 -544 316 -580 331 l-35 14 2 -552z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "layer102",
    fill: "#fefefe",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M702 2623 c-4 -10 -7 -211 -7 -447 l0 -429 372 -206 372 -206 3 -429 3 -430 315 -183 c352 -205 429 -247 438 -238 7 7 4 1129 -4 1475 l-7 266 -406 234 c-728 419 -1061 610 -1066 610 -3 0 -9 -8 -13 -17z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1065 1140 c-10 -16 -54 -43 -453 -272 -389 -224 -455 -264 -450 -279 2 -4 162 -101 357 -214 483 -281 550 -317 565 -312 20 8 28 292 20 717 -6 291 -10 370 -20 370 -7 0 -16 -5 -19 -10z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevvioLogo);
export default __webpack_public_path__ + "static/media/devvio-logo.3914fd4e14e63b8970622da4002f76db.svg";
export { ForwardRef as ReactComponent };